import Modal from "components/global/modal";
import { LiaTimesSolid } from "react-icons/lia";
import Select from "components/select/select";
import { useState } from "react";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";
// import { reportType } from "utils/constant";
import TextArea from "components/textarea/textarea";
import toast from "react-hot-toast";

import React, {useContext} from "react";
import { LangContext } from "context/language";
import { useTranslation } from "react-i18next";


const ReportPhotoVideo = ({
  hide,
  userData = {},
  media = {},
  type = "photo",
  ...props
}) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    comments: "",
    problem: "",
  });
  const {reportType} = useContext(LangContext)
  const [loading, setLoading] = useState(false);
  const { http } = global.services;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
  };

  const handlerOnSubmit = async () => {
    try {
      let payload = {};

      if (type === "photo" || type === "video") {
        const { id } = media; //Use this data when the report is about a photo
  
        payload = {
          ...state,
          gallery_id: id || null,  // id of user_galleries record
          type: type,
          link: window.location.href,
        };
      }

      setLoading(true);

      const result = await http.post(`public/reportMilestone`, payload);

      if (result.data.message) {
        hide();
        toast.success(result.data.message);
      }
    } catch (err) {
      if (err.status === 422) {
        return setState((prev) => ({
          ...prev,
          validationErrors: err.data?.errors,
        }));
      }

      toast.error(`It appears that something went wrong`);
    } finally {
      setLoading(false);
    }
  };

  const Footer = () => {
    return (
      <div className="relative grid gap-y-3 1sm:gap-y-0 1sm:flex 1sm:flex-row 1sm:items-center 1sm:justify-end 1sm:space-x-2">
        <Button
          buttonName={t("cancel")}
          buttonClass="bg-thBg py-5 px-12"
          buttonTextClass="text-black text-sm font-semibold"
          onClick={() => hide()}
        />
        <Button
          onClick={handlerOnSubmit}
          key="save-btn-category"
          buttonName={t("send")}
          buttonClass="bg-primary py-5 px-12"
          buttonTextClass="text-white text-sm font-semibold flex items-center"
          loadingIcon={
            loading ? (
              <LoadingIndicator className="text-white w-4 h-4 ml-2" />
            ) : null
          }
        />
      </div>
    );
  };

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-7/20 1xl:w-8/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full">
        <div className="flex justify-between border-b border-gray w-full px-4 py-6">
          <div className="font-bold text-[1.5rem]">Report {type.charAt(0).toUpperCase() + type.slice(1)}</div>
          <div>
            <LiaTimesSolid
              className="text-[1.5rem] cursor-pointer"
              onClick={() => hide()}
            />
          </div>
        </div>
        <div className="px-4 py-6">
          <div>
            <Select
              label="Please select a problem"
              options={reportType}
              placeholder="Please Select"
              name="type"
              height={58}
              value={
                state.problem &&
                reportType.filter((rm) => rm.value === state.problem)
              }
              onChange={(e) =>
                handleInputChange({
                  target: { name: "problem", value: e.value },
                })
              }
              errorMessage={state?.validationErrors?.problem}
            />
          </div>
          <div>
            <TextArea
              defaultValue={state.comments}
              type="text"
              onChange={handleInputChange}
              placeholder=""
              name="comments"
              label="Comments"
              errorMessage={state?.validationErrors?.comments}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReportPhotoVideo;
